import { render, staticRenderFns } from "./AIAvatarSlideTemplatePanel.vue?vue&type=template&id=083106bb&scoped=true"
import script from "./AIAvatarSlideTemplatePanel.vue?vue&type=script&lang=ts"
export * from "./AIAvatarSlideTemplatePanel.vue?vue&type=script&lang=ts"
import style0 from "./AIAvatarSlideTemplatePanel.vue?vue&type=style&index=0&id=083106bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083106bb",
  null
  
)

export default component.exports